module.exports = __webpack_public_path__ + "static/media/our-experts-bg-mobile.7f82c61f.png";